import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';

export const useReportsDownloadSummaryStyles = createStyles(({ token }) => ({
  selectionSectionFooter: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
    padding: `0 ${ThemeSpaces.SPACE_NORM_15}px`,
    backgroundColor: ThemeColors.COLOR_GREY9_9,
    border: `1px solid ${token.colorWhite}`,
    borderTopWidth: 0,
    borderBottomLeftRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,
    borderBottomRightRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,
    boxShadow: `0 2px 6px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.35)}, inset 0 -1px 8px ${ThemeColors.COLOR_GREY9_7}`,
    margin: `0 ${ThemeSpaces.SPACE_NORM0_5}px`,
  },

  summaryDateBody: {
    height: 50,
    justifyContent: 'center',
    fontSize: ThemeFont.FONT_SIZE_HEADING_1_5,
    fontFamily: ThemeFont.FONT_FAMILY6,
    color: token.colorPrimary,
  },

  // `&&` outranks reportsShared.styles.js's `selectionSection` base rule
  // (equal specificity otherwise, since both are applied directly).
  selectionSectionSummary: {
    '&&': {
      flex: 'initial',
      padding: ThemeSpaces.SPACE_NORM_20,
      paddingTop: ThemeSpaces.SPACE_NORM_30,
      marginTop: -ThemeSpaces.SPACE_NORM - 1,
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
    },
  },
}));
